import { createSlice } from "@reduxjs/toolkit";

import { fetchOpportunityToProposal } from "./actions";

export const initialState = {
  data: null,
  isLoading: false,
  error: null,
};

const DEFAULT_ERROR = "Failed to load opportunity to proposal data.";

const opportunityToProposalSlice = createSlice({
  name: "opportunityToProposal",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchOpportunityToProposal.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchOpportunityToProposal.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(fetchOpportunityToProposal.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error?.message ?? DEFAULT_ERROR;
      });
  },
});

export default opportunityToProposalSlice.reducer;
